export function waitTronAddress(tronWeb) {
  return new Promise((resolve, reject) => {
    try {
      let retry = 0;
      if (tronWeb.defaultAddress && tronWeb.defaultAddress.base58) {
        resolve(tronWeb.defaultAddress.base58);
        return;
      }

      const timer = setInterval(() => {
        if (retry >= 5) {
          clearInterval(timer);
          reject(new Error("Tron address not ready"));
          return;
        }

        retry += 1;
        if (tronWeb.defaultAddress && tronWeb.defaultAddress.base58) {
          clearInterval(timer);
          resolve(tronWeb.defaultAddress.base58);
        }
      }, 200);
    } catch (err) {
      reject(err);
    }
  });
}

export function connectTronWallet() {
  return new Promise((resolve, reject) => {
    if (!window.tronWeb) {
      reject(new Error("TronWeb provider not found"));
      return;
    }

    waitTronAddress(window.tronWeb)
      .then(() => resolve(window.tronWeb))
      .catch(reject);
  });
}

// 静默读取"用户此前已授权"的 EVM 账户：eth_accounts 不会弹窗，
// 没授权过就返回空数组（区别于会弹窗的 eth_requestAccounts）。
export async function getEvmAccountsSilently() {
  if (typeof window === "undefined") return [];
  const eth = window.ethereum;
  if (!eth || !eth.request) return [];
  try {
    const list = await eth.request({ method: "eth_accounts" });
    return Array.isArray(list) ? list.filter(Boolean) : [];
  } catch (err) {
    return [];
  }
}

// 读取钱包当前真实的 EVM chainId（十六进制字符串，如 "0x2105"）
export async function getEvmChainId() {
  if (!window.ethereum || !window.ethereum.request) return "";
  try {
    const id = await window.ethereum.request({ method: "eth_chainId" });
    return typeof id === "string" ? id : "";
  } catch (e) {
    return "";
  }
}

// 切换（必要时先添加）到指定 EVM 网络，例如 Base
export async function switchToChain(chain) {
  if (!window.ethereum || !window.ethereum.request) {
    throw new Error("Ethereum provider not found");
  }
  try {
    await window.ethereum.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: chain.chainIdHex }],
    });
  } catch (err) {
    const code = err && (err.code || (err.data && err.data.originalError && err.data.originalError.code));
    if (code === 4902) {
      // 钱包里还没有该网络，先添加（添加成功即切到该网络）
      await window.ethereum.request({
        method: "wallet_addEthereumChain",
        params: [
          {
            chainId: chain.chainIdHex,
            chainName: chain.chainName,
            nativeCurrency: chain.nativeCurrency,
            rpcUrls: chain.rpcUrls,
            blockExplorerUrls: chain.blockExplorerUrls,
          },
        ],
      });
      return;
    }
    throw err;
  }
}

export function connectEthWallet(Web3Ctor) {
  return new Promise(async (resolve, reject) => {
    if (!window.ethereum) {
      if (window.web3) {
        resolve(window.web3);
      } else {
        reject(new Error("Ethereum provider not found"));
      }
      return;
    }

    try {
      const web3 = new Web3Ctor(window.ethereum);
      if (window.ethereum.request) {
        await window.ethereum.request({ method: "eth_requestAccounts" });
      } else if (window.ethereum.enable) {
        await window.ethereum.enable();
      }
      resolve(web3);
    } catch (err) {
      reject(err);
    }
  });
}

function pickSolProvider() {
  if (window.solana && window.solana.isPhantom) return window.solana;
  if (window.solana) return window.solana;
  if (window.phantom && window.phantom.solana) return window.phantom.solana;
  return null;
}

export function connectSolWallet() {
  return new Promise(async (resolve, reject) => {
    const provider = pickSolProvider();
    if (!provider) {
      reject(new Error("Solana provider not found"));
      return;
    }

    try {
      if (provider.connect) {
        await provider.connect();
      } else if (provider.request) {
        await provider.request({ method: "connect" });
      }

      if (!provider.publicKey && provider.isConnected === false) {
        reject(new Error("Solana wallet not connected"));
        return;
      }

      resolve(provider);
    } catch (err) {
      reject(err);
    }
  });
}
